import React from "react";
import "./Legal.css";
import SEO from "../../Components/SEO";

function RefundPolicy() {
  return (
    <>
      <SEO title="Refund Policy" description="Lutology Refund Policy" />
      <main
        className="legal-page"
        role="main"
        aria-label="Lutology Refund Policy"
      >
        <h1>Refund Policy</h1>
        <p className="legal-meta">Last updated: July 2026</p>

        {/* Required by Google Merchant Center */}
        <p>We accept returns for damaged, incorrect, or undelivered items.</p>

        <p>
          We want you to be satisfied with your Lutology™ purchase. If something
          goes wrong with your order, we will do our best to make it right.
        </p>

        <h2>1. General</h2>
<p>
  Unopened products may be returned within 30 days of delivery. Because our
  products are cosmetic and for personal use, we generally cannot accept returns
  of opened items unless there is a quality issue, damaged item, or incorrect
  item.
</p>
<p>
  Return shipping costs are the customer’s responsibility, unless the item
  arrived damaged, incorrect, or there was a fulfillment issue on our side.
</p>

        <h2>2. Orders That Did Not Arrive</h2>
        <p>
          If your order has not arrived after a reasonable timeframe, per our{" "}
          <strong>Shipping Policy</strong>, please contact us.
        </p>
        <p>We will offer you:</p>
        <ul>
          <li>A free replacement shipment, or</li>
          <li>A full refund.</li>
        </ul>

        <h2>3. Damaged or Incorrect Items</h2>
        <p>
          If your order arrives damaged or incorrect, please contact us promptly
          with photos.
        </p>

        <h2>4. Cancellations</h2>
        <p>
          If your order has not been shipped yet, cancellations are usually
          possible.
        </p>

        <h2>5. Opened Products</h2>
        <p>
          Opened products generally cannot be returned unless there is a quality
          or safety issue.
        </p>

        <h2>6. Refund Method</h2>
        <p>
          Refunds are issued via the same payment method used in the original
          purchase.
        </p>

        <h2>7. How to Contact Us</h2>
        <p>
          For any refund or order-related questions, please{" "}
          <a href="/contact" className="legal-link">
            contact us via our Contact page
          </a>
          .
        </p>
      </main>
    </>
  );
}

export default RefundPolicy;
